import { Scene3D } from '@/components/motion/Scene3D';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <section className="status-page relative overflow-hidden text-center">
      <Scene3D className="status-scene" />
      <p className="font-mono text-6xl font-bold text-brand-500">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-surface-50">Sayfa bulunamadı</h1>
      <p className="mt-3 text-surface-400">
        Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.
      </p>

      <Link to="/" className="gf-button gf-button-primary mt-8">
        Ana sayfaya dön
      </Link>
    </section>
  );
}
